import colors from '@constants/colors';
import { IconProps } from '@models/icons';

function MessageIcon({ size = 16, color = colors.gray7, ...rest }: IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path
                d="M12.6663 10.6667H10.983C10.8836 10.6667 10.7855 10.6893 10.6961 10.7326C10.6066 10.7758 10.5281 10.8388 10.4663 10.9167L8.51634 13.35C8.45389 13.4281 8.37466 13.4912 8.28453 13.5345C8.1944 13.5778 8.09568 13.6003 7.99567 13.6003C7.89567 13.6003 7.79695 13.5778 7.70682 13.5345C7.61669 13.4912 7.53746 13.4281 7.47501 13.35L5.52501 10.9167C5.4632 10.8387 5.38456 10.7757 5.29497 10.7324C5.20539 10.6891 5.10717 10.6666 5.00767 10.6667H3.33301C2.22501 10.6667 1.33301 9.77467 1.33301 8.66667V4C1.33301 2.892 2.22501 2 3.33301 2H12.6663C13.775 2 14.6663 2.892 14.6663 4V8.66667C14.6663 9.77467 13.775 10.6667 12.6663 10.6667Z"
                fill={color}/>
        </svg>
  );
}

export default MessageIcon;
